<template>
  <div>
    <v-row>
      <v-col :cols="6">
        <DatePickerWithMenu
          class="mb-n4"
          :default="todaysDate"
          :label="label"
          @date-selected="getSelectedDate"
        ></DatePickerWithMenu>
      </v-col>
      <v-col :cols="6">
        <v-text-field
          class="mx-4 mt-4"
          type="number"
          v-model="discountAmount"
          :label="'Discount(' + getCurrency + ')'"
          placeholder="Discount Amount"
          @change="getDiscountAmount"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <vTextArea
          label="Comment"
          hint="Comment goes here"
          class="mx-4 mt-n6"
          :defaultValue="content"
          @get-content="getCommentContent"
        >
        </vTextArea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import vExpansionPanel from "@/components/Legos/vExpansionPanel.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import vInputField from "@/components/Legos/vInputField.vue";
import vTextArea from "@/components/Legos/vTextArea.vue";

export default {
  props: {
    label: {
      default: "Invoice Date",
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  components: {
    vExpansionPanel,
    DatePickerWithMenu,
    vInputField,
    vTextArea,
  },
  data: () => ({
    todaysDate: new Date().toISOString().substring(0, 10),
    discountAmount: 0,
    content: null,
  }),
  methods: {
    getSelectedDate(selectedDate) {
      this.todaysDate = selectedDate;
      this.$emit("date-selected", selectedDate);
    },
    getDiscountAmount() {
      this.$emit("get-discount-amount", this.discountAmount);
    },
    getCommentContent(content) {
      this.content = content;
      this.$emit("get-comment", content);
    },
  },
};
</script>

<style></style>
